// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Bp-z","selected":"Cp-z"};